import { Stack, TextInput, Button, Group, Text } from "@mantine/core";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import Link from "next/link";
import { useState } from "react";
import { logSubscribeToNewsletter, setBrowserEmail } from "../lib/logger";
import { Price } from "./Localization";
import styles from './EmailCapture.module.scss';

type formValues =
{
  email:string;
}


export default function EmailCapture()
{

  //have to define this as a separate component to prevent odd bugs

  const form = useForm<formValues>({
    initialValues: {
      email: '',
    }
});

let [submitting, setSubmitting] = useState(false);
 

async function submitHandler(data : formValues)
{

  setSubmitting(true);
  await fetch('/n/api/subscribe', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
    credentials:"include"
  });
  logSubscribeToNewsletter();
  await setBrowserEmail(data.email);

  setSubmitting(false);
  modals.closeAll();
}

return <>
<form onSubmit={form.onSubmit(async (values) => await submitHandler(values))}>
<Stack>

<Text>Would you like to subscribe to our mailing list?</Text>
<Text>We&rsquo;ll keep you informed about upcoming online sessions, workshops and events. Plus we’ll give you access to <b>SEVEN</b> of our previous sessions, all for <b>FREE</b>, and a voucher worth <Price gbp={5}/> for a future livestream</Text>


  <TextInput
    width={300}
    type='email'
    required
    label="Email"
    placeholder="hello@example.com"
    value={form.values.email}
    onChange={(event: React.ChangeEvent<HTMLInputElement>) => form.setFieldValue('email', event.currentTarget.value)}
    error={form.errors.email && 'Invalid email'}
  />
    <Group justify="center">
          <Button disabled={submitting} type="submit">Yes please! Subscribe me.</Button>
<Button variant = 'outline' disabled={submitting} onClick={() => modals.closeAll()}>No thank you</Button>

</Group>
</Stack>


<div className={styles.privacyPolicy}>
We won&rsquo;t sell or share your data and you can unsubscribe at any time. You can see our privacy policy <Link href='/privacy-policy'>here</Link>
</div>
</form>
</>

}
